import React from 'react';

const Navbar: React.FC = () => {
  return (
    <nav className="bg-primary p-4 text-background shadow-md">
      <div className="container mx-auto flex justify-between items-center">
        <h1 className="text-2xl font-heading font-bold">Mathdle</h1>
        <ul className="flex space-x-4">
          {/* <li><a href="#" className="hover:text-secondary transition-colors">Home</a></li>
          <li><a href="#" className="hover:text-secondary transition-colors">How to Play</a></li>
          <li><a href="#" className="hover:text-secondary transition-colors">About</a></li> */}
          <li><a href="#privacy" className="hover:text-secondary transition-colors">Privacy Policy</a></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;